<mat-progress-bar mode="indeterminate" *ngIf="!isLoaded"></mat-progress-bar>
<div fxLayout="column" fxLayoutAlign="start center">
  <canvas #pdf [width]="width" [height]="height" class="bg-white"></canvas>
</div>
